import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function useAuth() {
  const { session, user, profile, initialized, signIn, signUp, signOut, init, loading } =
    useAuthStore();

  useEffect(() => {
    if (!initialized) void init();
  }, [initialized, init]);

  return {
    session,
    user,
    profile,
    initialized,
    loading,
    isAuthed: !!session,
    isAdmin: profile?.role === 'admin',
    isCliente: profile?.role === 'cliente',
    isDistribuidor: profile?.role === 'distribuidor',
    signIn,
    signUp,
    signOut,
    init,
  };
}
